import { LockClosedIcon } from '@heroicons/react/20/solid';
import { FC } from 'react';
import { MdEmail, MdPublic } from 'react-icons/md';

import { BoardAccessTypeEnum } from '@/ux-legacy/components/common/bentoboard/Common/board-types';

const PortalAccessType: FC<{ accessType: string }> = ({ accessType }) => {
  return (
    <>
      {accessType == BoardAccessTypeEnum.NONE && <MdPublic className="w-full h-full" />}
      {accessType == BoardAccessTypeEnum.EMAIL && <MdEmail className="w-full h-full" />}
      {accessType == BoardAccessTypeEnum.PASSWORD && <LockClosedIcon className="w-full h-full" />}
    </>
  );
};

export default PortalAccessType;
